/*
<el-dialog title=""
           :visible.sync="visibleValue"
           :close-on-press-escape="false"
           :close-on-click-modal="false"
           :modal-append-to-body="true"
           :append-to-body="true"
           @closed="closedCallback">
</el-dialog>
 */
/**
 * el-dialog mixins
 */
export let mixinsDialog = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      visibleValue: false, // 弹窗是否显示
    }
  },
  created() {
    this.visibleValue = !!this.visible;
  },
  methods: {
    /**
     * 关闭回调
     */
    closedCallback() {
      this.$emit('closed');
    },
    /**
     * 关闭当前弹窗
     */
    closedDialog(){
      this.visibleValue = false;
    },
  },
  computed:{
    /**
     * 用来给页面监听弹窗显示/隐藏，避免监听覆盖 visible、visibleValue 时忘记执行默认事件
     * @returns {boolean}
     */
    isShow(){
      return this.visibleValue
    },
  },
  watch: {
    /** 接收 */
    visible(newValue) {
      this.visibleValue = newValue
    },
    /** 冒泡 */
    visibleValue(newValue) {
      this.$emit('update:visible', newValue)
    },
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/my-element-mixins/src/mixins/dialog.js
// module id = null
// module chunks = 